/**
*
* FormModal
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Modal } from 'react-bootstrap';
import Form4 from 'components/interaction/Form4/index.jsx';

function FormModal(props) {
  const {
    show, size, onHide, onSubmit, values, schema, title, children, ...rest
  } = props;

  function handleSubmit(data) {
    onSubmit(data);
    onHide();
  }

  return (
    <Modal show={show} onHide={onHide} size={size} backdrop="static" keyboard={false}>
      <Modal.Header>
        <Modal.Title>
          <FormattedMessage {...title} />
        </Modal.Title>
      </Modal.Header>
      {show && (
        <Form4
          onSubmit={handleSubmit}
          onCancel={onHide}
          schema={schema}
          defaultValues={values}
          {...rest}
        >
          {({ body, action }) => (
            <>
              <Modal.Body>
                {children}
                {body}
              </Modal.Body>
              <Modal.Footer>
                {action}
              </Modal.Footer>
            </>
          )}
        </Form4>
      )}
    </Modal>
  );
}

FormModal.propTypes = {
  show: PropTypes.bool,
  size: PropTypes.string,
  values: PropTypes.object,
  schema: PropTypes.object,
  title: PropTypes.object,
  onHide: PropTypes.func,
  onSubmit: PropTypes.func,
  children: PropTypes.node,
};

export default FormModal;
